import { render, staticRenderFns } from "./MaintainancePage.vue?vue&type=template&id=4078a71e&scoped=true&"
import script from "./MaintainancePage.vue?vue&type=script&lang=js&"
export * from "./MaintainancePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4078a71e",
  null
  
)

export default component.exports